export default __webpack_public_path__ + "static/media/Events.d6ee6ae0.svg";